export default __webpack_public_path__ + "static/media/MiniTape_SideA_03_Telefonbeantorter-Binggeli-Ueli.ea65bd61.mp3";